import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ClienteLogin, ClienteVAM, UsuarioVamTit } from '../../login/cliente_login';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { correctHeight, detectBody, smoothlyMenu } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage";
import { PolizaEntity } from '../../empresas/entities/polizas_cliente_entity';
import { VamTitularesPolizasService } from './vam-titulares-polizas.service';
import { ConsultarUsuarioVAM } from '../../../components/common/utils/consultarUsuarioVAM';
import { RedesVamEntity, PlanVamEntity, BeneficiosPlan, Detalles, DependientesVam, TipRcl, Reclamo, DocumentosPorAseguradora, DocumentoReclamo, InfoPoliza, InfoPersona, DiagnosticoEntity } from '../vam_entity';
import { SiniestrosVamTit, SiniestroVam } from '../titulares/entities/vam_titulares_entity';
import { UtilService } from '../../../components/common/utils/util.service';
import { SiniestroTracking, SiniestroTrackingVam } from '../../siniestros/siniestros_entity';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ModalComponent } from '../../../../../node_modules/ng2-bs3-modal/ng2-bs3-modal';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';


const swal = require("sweetalert2");


declare var jQuery: any;

@Component({
  selector: 'vamTittularPolizas',
  providers: [VamTitularesPolizasService],
  templateUrl: 'vam-titulares-polizas.template.html',
  styleUrls: ['vam-titulares-polizas.styles.css']

})

export class vamTitularesPolizas implements OnInit {

  usuario: ClienteLogin;
  clienteVam: ClienteVAM;
  usuarioVam: UsuarioVamTit;
  polizas: PolizaEntity[];
  redes: RedesVamEntity[];
  planes: PlanVamEntity[];
  beneficios: BeneficiosPlan;
  public showLoader: string;
  public showLoader1: string;
  opcion: number;
  coberturas: Detalles[];
  rowSelect: number;
  listSiniestrosVamTit: SiniestrosVamTit;
  sinCerrados: boolean;
  sinPendientes: boolean;
  dependientes: InfoPersona[];
  trackVamPen: SiniestroTrackingVam;
  trackVamCerr: SiniestroTrackingVam;
  banderaTrackingPen: boolean = false;
  banderaTrackingCerr: boolean = false;
  VigenciaAnterior: boolean;
  polizasAnterior: PolizaEntity;
  Accion: number;
  current: number;

  tipoReclamo: number;
  titular: string;
  polizaReclamo: PolizaEntity = undefined;
  tiposReclamo: TipRcl[] = new Array<TipRcl>();
  nombreTitular: string = "";
  dependienteRcl: number;
  reclamo: Reclamo = new Reclamo();
  UriVam: string;
  documentos: DocumentosPorAseguradora[] = new Array<DocumentosPorAseguradora>();
  docsCliente: DocumentoReclamo[] = new Array<DocumentoReclamo>();
  diagnosticos: DiagnosticoEntity[] = new Array<DiagnosticoEntity>();
  formData: FormData = new FormData();
  files: File[] = [];
  url: string = "vamTittular";
  devolverMensaje: any;
  @ViewChild('agendarCita')
  modalPass: ModalComponent;
  urlAsesor: string = ''
  banderaCita: boolean = false;
  codigoDiagnostico: number;
  valorPresentado: number;
  telefonoTitular: string;
  EmailTitular: string;

  sin: SiniestroVam =  new SiniestroVam();

  presentarAsesor: boolean = false;
  constructor(
    private vamTitularesPolizasService: VamTitularesPolizasService,
    private router: Router,
    private sessionTokenService: SessionTokenService,
    private handleError: HandleError,
    private sesionStorageService: SessionStorageService,
    private consultarVAM: ConsultarUsuarioVAM,
    public utilService: UtilService,
    protected sanitizer: DomSanitizer
  ) {
    this.diagnosticos= new Array<DiagnosticoEntity>();
    let constantService = new ConstantService();
    this.url = constantService.API_ENDPOINT + this.url;
    this.trackVamCerr = new SiniestroTrackingVam();
    this.trackVamPen = new SiniestroTrackingVam();
    this.devolverMensaje = (parametro: number, reclamo: any): void => {
      if (parametro == 200) {
        let rcl = JSON.parse(reclamo);
        swal({
          title: 'Reclamo Guardado',
          text: "Su información ha sido enviada satisfactoriamente, el código de tracking es: #" + rcl.CodigoTracking,
          type: 'success'
        });

        this.docsCliente = new Array<DocumentoReclamo>();
        this.dependienteRcl = undefined;
        this.tipoReclamo = undefined;
        this.showLoader = "";
        this.formData = new FormData();
      }
      else {
        swal({
          title: 'Reclamo',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.showLoader = "";
        this.formData = new FormData();
      }
    }
  }
  ngOnInit() {
    this.polizas = new Array<PolizaEntity>();
    this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
    this.consultarVAM.iniciarUsuarioVAM();
    this.clienteVam = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
    this.VigenciaAnterior = false;
    let hoy = new Date();
    let fechaSalida = new Date();
    fechaSalida.setFullYear(2020);
    fechaSalida.setMonth(6);
    fechaSalida.setDate(3);
    if(hoy >= fechaSalida){//cambio del asesor virtual visible desde el 03 de agosto del 2020 eliminar esta validación después de esa fecha :)
      this.presentarAsesor = true;
    }
    if (this.usuario == null) {
      let error = { "status": 998, "message": "Acceso denegado" };
      this.handleError.redirectUrl(error)
    } else {
      let bandera = this.sessionTokenService.useJwtHelper();
      if (!bandera) {
        this.CargarPolizas(this.clienteVam, this.usuario.Cedula);
        this.listSiniestrosVamTit = new SiniestrosVamTit();
        this.listSiniestrosVamTit.sinPendientes = new Array<SiniestroVam>();
        this.listSiniestrosVamTit.sinCerrados = new Array<SiniestroVam>();
      }
    }
  }

  CargarPolizas(vamTit: ClienteVAM, cedula: string) {
    this.usuarioVam = new UsuarioVamTit();
    this.usuarioVam.CodigoCiudad = vamTit.CodigoCiudad;
    this.usuarioVam.CodigoCliente = vamTit.CodigoCliente;
    this.usuarioVam.CodigoUnidad = vamTit.CodigoUnidad;
    this.usuarioVam.Cedula = cedula;
    this.showLoader1 = "sk-loading";
    this.vamTitularesPolizasService.ConsultarPolizasVamTitular(this.usuarioVam).subscribe(
      result => {
        this.polizas = result;
        this.showLoader1 = "";
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }
  OpcionesChangePoliza(poliza: PolizaEntity, opcion: number, IdRow: number) {
    this.rowSelect = IdRow;
    if (opcion == 0)
      this.opcion = 0;

    if (opcion == 1) {/*Redes*/
      this.opcion = 1;
      this.CargarRedes(poliza);
    }
    if (opcion == 2) {/*Planes*/
      this.opcion = 2;
      this.CargarPlanes(poliza);
    }

    if (opcion == 3) {/*Siniestros*/
      this.opcion = 3;
      this.CargarSiniestros(poliza);
    }

    if (opcion == 4) {/*Dependientes*/
      this.opcion = 4;
      this.CargarDependientes(poliza);
    }


  }
  IngresarReclamo(poliza: PolizaEntity){
    this.docsCliente = new Array<DocumentoReclamo>();
    this.polizaReclamo = JSON.parse(JSON.stringify(poliza));
    this.opcion = 5;
    const consulta = new InfoPoliza();
    consulta.CodAseguradora = this.polizaReclamo.CodigoAseguradora;
    consulta.CodPoliza = this.polizaReclamo.CodigoPoliza;
    consulta.CodRamo = this.polizaReclamo.CodigoRamo;
    consulta.CodigoCiudad = this.polizaReclamo.CodigoCiudad;
    consulta.CodigoCliente = this.polizaReclamo.CodigoCliente;
    consulta.TipoNegocio = this.polizaReclamo.CodigoTipoNegocio;

    this.vamTitularesPolizasService.GetUriVam().subscribe(
      result => {
        this.UriVam = result;
      }
    );
    this.CargaIngresoReclamos(this.polizaReclamo, consulta);
    this.CargarDiagnosticos();
  }

  CargaIngresoReclamos(poliza: PolizaEntity, consulta: InfoPoliza) {
    this.showLoader1 = "sk-loading";
    this.vamTitularesPolizasService.GetTipoReclamo(poliza.CodigoTipoNegocio, poliza.CodigoRamo).subscribe(
      result => {
        this.tiposReclamo = result;
        this.showLoader1 = "";
      },
      error => {
        this.handleError.redirectUrl(error);
        this.showLoader1 = "";
      }
    );
    const cli = new ClienteLogin();
    cli.Cedula = this.usuario.Cedula;
    this.vamTitularesPolizasService.GetVamTitular(cli).subscribe(
      result => {
        this.nombreTitular = result.PrimerNombre + " " + result.SegundoNombre + " " + result.ApellidoPaterno + " " + result.ApellidoMaterno;
        consulta.TitCod = result.CodigoTitular;
        this.vamTitularesPolizasService.ConsultarDependientes(consulta).subscribe(
          resultDep => {
            this.dependientes = resultDep;
            this.showLoader = "";
          },
          error => { this.handleError.redirectUrl(error); }
        );

      }
    );
  }
  CargarDiagnosticos() {
    this.showLoader = "sk-loading";
    this.vamTitularesPolizasService.GetDiagnosticos().subscribe(
      result => {
        this.diagnosticos = result;
        this.showLoader = "";
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }


  CargarRedes(poliza: PolizaEntity) {
    this.showLoader = "sk-loading";
    this.vamTitularesPolizasService.ConsultarRedesVamTitular(poliza).subscribe(
      result => {
        this.redes = result;
        this.showLoader = "";
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }

  CargarPlanes(poliza: PolizaEntity) {
    this.showLoader = "sk-loading";
    this.beneficios = new BeneficiosPlan();
    this.coberturas = new Array<Detalles>();
    this.vamTitularesPolizasService.ConsultarPlanes(poliza).subscribe(
      result => {
        this.planes = result;
        this.showLoader = "";
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }

  CargarSiniestros(poliza: PolizaEntity) {
    this.showLoader = "sk-loading";
    this.beneficios = new BeneficiosPlan();
    this.coberturas = new Array<Detalles>();
    this.polizasAnterior = poliza;
    this.vamTitularesPolizasService.ConsultarSiniestros(poliza).subscribe(
      result => {
        this.listSiniestrosVamTit = result;
        if (this.listSiniestrosVamTit.sinCerrados.length != 0)
          this.sinCerrados = true;
        else
          this.sinCerrados = false;

        if (this.listSiniestrosVamTit.sinPendientes.length != 0)
          this.sinPendientes = true;
        else
          this.sinPendientes = false;


        this.showLoader = "";
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }

  CargarDependientes(poliza: PolizaEntity) {
    this.showLoader = "sk-loading";
    this.vamTitularesPolizasService.ConsultarDependientesVam(poliza).subscribe(
      result => {
        this.dependientes = result;
        this.showLoader = "";
      },
      error => { this.handleError.redirectUrl(error); }
    );

  }

  ConsultarSinVam(siniestro: SiniestroVam, bandera: number) {
    this.utilService.ConsultarSiniestroVam(siniestro).subscribe(
      result => {
        this.sin = siniestro;
        if (bandera == 1) {
          this.banderaTrackingPen = true;
          this.banderaTrackingCerr = false;
          this.trackVamPen = result;
          this.trackVamCerr = new Object();

        } else {
          this.banderaTrackingPen = false;
          this.banderaTrackingCerr = true;
          result.Cobertura=null;
          this.trackVamCerr = result;
          this.trackVamPen = new Object();
          console.log("pruebas",this.trackVamCerr)
        }
      },
      error => {
        this.handleError.redirectUrl(error);
      }
    );
  }

  checkValue() {
    if (this.VigenciaAnterior == true) {
      this.polizasAnterior.Opcion = 2;
      this.CargarSiniestros(this.polizasAnterior);
    }
    else {
      this.polizasAnterior.Opcion = 0;
      this.CargarSiniestros(this.polizasAnterior);
      this.banderaTrackingPen = false;
      this.banderaTrackingCerr = false;
    }
  }

  getDocumentos() {
    this.docsCliente = new Array<DocumentoReclamo>();
    if (this.tipoReclamo != null && this.tipoReclamo != undefined) {
      this.vamTitularesPolizasService.GetTipoDocumentosParaRclByAseguradora(
        this.polizaReclamo.CodigoAseguradora,
        this.tipoReclamo).subscribe(
          result => {
            this.documentos = result;
            console.log("this.documentos");
            console.log(this.documentos);

           /* this.vamTitularesPolizasService.GetFormularioPath(this.polizaReclamo.CodigoAseguradora).subscribe(
              resultPath => {
                //var formulario = resultPath;

              }
            );*/
          }
        );
    }
  }

  CrearDocumento() {
    let a = this.docsCliente.length;
    let codigo = 1;

    codigo =
      Math.max.apply(
        Math,
        this.docsCliente.map(function (o) {
          return o.Codigo;
        })
      ) + 1;
    if (!isFinite(codigo)) {
      codigo = 1;
    }

   let doc = new DocumentoReclamo();
    doc.Codigo = codigo;
    this.docsCliente.push(doc);
  }

  fileChange(archivo: any, doc: DocumentoReclamo) {
    let archivoEncontrado = undefined;
    if (this.files != undefined) {
      archivoEncontrado = this.files.filter(a => a.name == archivo.target.files[0].name);
    }
    if (archivoEncontrado != null && archivoEncontrado != undefined && archivoEncontrado.length > 0) {
      swal({
        title: 'Archivo ',
        text: "El nombre de archivo ya existe, por favor modifique su nombre",
        type: 'error'
      });
    } else {
      doc.NombreArchivo = archivo.target.files[0].name;
      doc.TipoMIME = archivo.target.files[0].type;

      /*doc.ArchivoByte = archivo;
      var r = new FileReader();
      r.onload = function (e) {
        doc.ArchivoByte = r.result
      }
      r.readAsArrayBuffer(archivo.target.files[0]);*/

      this.files.push(archivo.target.files[0]);
    }
  }
  eliminarArchivo(doc: DocumentoReclamo) {
    this.docsCliente = JSON.parse(JSON.stringify(this.docsCliente.filter(a => a.Codigo != doc.Codigo)));
    this.files = this.files.filter(a => a.name != doc.NombreArchivo);
  }

  EnviarReclamo() {
    this.showLoader = "sk-loading";
    let reclamo = new Reclamo();

    reclamo.CodigoCiudad = this.polizaReclamo.CodigoCiudad;
    reclamo.CodigoCliente = this.polizaReclamo.CodigoCliente;
    reclamo.CodigoDiagnostico= this.codigoDiagnostico;
    reclamo.ValorPresentado=this.valorPresentado;
    reclamo.TelefonoTitular=this.polizaReclamo.TelefonoTitular;
    reclamo.EmailTitular=this.polizaReclamo.EmailTitular;

    let dep = this.dependientes.filter(a => a.CodigoPersona == this.dependienteRcl)[0];
    reclamo.CodigoTitular = dep.CodigoTitular;

    if (this.dependienteRcl != reclamo.CodigoTitular) {
      reclamo.CodigoDependiente = this.dependienteRcl;
    }

    reclamo.NombrePaciente = dep.NombrePersona;
    reclamo.Placod = dep.PlaCod;
    reclamo.Platitcod = dep.PlaTitCod;
    reclamo.Poliza = dep.PolCod;
    reclamo.Ramo = dep.Ramo;
    reclamo.TipoNegocio = dep.TipoNegocio;
    reclamo.TipoPaciente = dep.TipoPersona;
    reclamo.TipoReclamo = this.tipoReclamo;
    reclamo.Unidad = dep.CodigoUnidad;
    reclamo.AppOrigen = 1;
    reclamo.Aseguradora = dep.CodigoAseguradora;
    reclamo.DocumentosReclamo = JSON.parse(JSON.stringify(this.docsCliente));
    reclamo.DocumentacionCompleta = true;
    reclamo.DocumentacionCompleta = false;
   /* this.documentos.forEach(b => {
      let docs = this.docsCliente.filter(a => a.TipoDocumento == b.codigoDocumento);
      if (docs == null || docs == undefined || docs.length == 0) {

      }
    });*/

    this.files.forEach(a => {
      this.formData.append(a.name, a, a.name);
    })

    this.formData.append("Reclamo", JSON.stringify(reclamo));


    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = (function () {
      if (xhr.readyState === 4) {
        this.devolverMensaje(xhr.status, xhr.response);
      }
    }).bind(this);
    xhr.open("post", this.url + '/GetGuardarReclamo', true);
    xhr.setRequestHeader("enctype", "multipart/form-data");
    // IE workaround for Cache issues
    xhr.setRequestHeader("Cache-Control", "no-cache");
    xhr.setRequestHeader("Cache-Control", "no-store");
    xhr.setRequestHeader("Pragma", "no-cache");
    xhr.setRequestHeader("Authorization", "Token " + this.sesionStorageService.retrieve("Token"));
    xhr.setRequestHeader("Reclamos", JSON.stringify(reclamo));

    xhr.send(this.formData);
  }

  abrirAgendarCita() {
    this.utilService.getUriAsesorVirtual(3).subscribe(
      result => {
        let ruta = result;
        const cli = new ClienteLogin();
        cli.Cedula = this.usuario.Cedula;
        this.vamTitularesPolizasService.GetVamTitular(cli).subscribe(
          resulttit => {
            // AsesorVirtualVAM/:cliCod/:titCod/:ciuCod/:uniCod/:TipoProceso/:OrigenApp/:CodigoPlanTitular
            //ruta = ruta + poliza.CodigoCliente + "/" + resulttit.CodigoTitular + "/" + poliza.CodigoCiudad + "/" + poliza.CodigoUnidad + "/6/1/"+poliza.CodigoPlanTitular;
            ruta = ruta +this.clienteVam.CodigoCliente+ "/" + resulttit.CodigoTitular + "/" + this.clienteVam.CodigoCiudad + "/" + this.clienteVam.CodigoUnidad + "/6/1/0";

            this.urlAsesor = ruta;
            console.log(ruta)
            this.banderaCita = true;
            this.modalPass.open();
          }
        );
      }
    );
  }

  CerrarModal() {
    this.banderaCita = false;
    this.urlAsesor = "";
  }
  DescargarAdjuntosTrackin(siniestro:SiniestroVam){
    console.log(siniestro);
    this.vamTitularesPolizasService.getAdjuntoSiniestro(siniestro).subscribe(result => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.className = "hidden";
        let fileBlob = result.blob();
        let blob = new Blob([fileBlob], {
            type: 'application/pdf' // must match the Accept type
        });
        let url = window.URL.createObjectURL(blob);
        a.href = url;
        let codigoAutogenerado = new Date();
        a.download = siniestro.NumSiniestroAse + ".pdf";

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, siniestro.NumSiniestroAse + ".pdf");
        }
        else {
            a.click();
            window.URL.revokeObjectURL(url);
            // var objectUrl = URL.createObjectURL(blob);
            //  window.open(objectUrl);
        }
        this.showLoader = "";
        swal({
            title: 'Adjunto generado',
            text: 'Se ha descargardo el adjunto seleccionado.',
            type: 'success',
            confirmButtonColor: '#A14950',
            confirmButtonText: 'Aceptar'
        })

    }, error => {
        this.showLoader = "";
        swal({
            title: 'Adjunto no generado',
            text: 'El archivo no existe o no se encuentra en el directorio indicado.',
            type: 'warning',
            confirmButtonColor: '#A14950',
            confirmButtonText: 'Aceptar'
        })
    });
  }

}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/polizas/vam-titulares-polizas.component.ts